import React, {useState, useEffect, useRef} from "react";
import {authenticationService} from "../Scripts/authentication.service";
import Title from "../Comps/Title";
import {useParams} from "react-router-dom";
import {APIProvider, Map, Pin, AdvancedMarker, useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {handleResponse} from "../Scripts/handle-response";
import Loading from "../Loading/Loading";
import Button from "../Comps/Button";
import ReactCanvasConfetti from "react-canvas-confetti";

const CrawlView = () => {
    const [user] = useState(authenticationService.currentUserValue)
    const { id } = useParams()
    const [pubs, setPubs] = useState([])
    const [crawl, setCrawl] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [open, setOpen] = useState(false)
    const [currentPub, setCurrentPub] = useState({})
    const confettiRef = useRef(null);

    const onInit = ({ confetti }) => {
        confettiRef.current = confetti
    }

    const fire = () => {
        if (confettiRef.current) {
            confettiRef.current({
                startVelocity: 45,
                decay: 0.92,
                scalar: 1.2,
                spread: 180,
                ticks: 90,
                zIndex: 0,
                particleCount: 300,
                origin: {
                    x: 0.5,
                    y: 1.0
                }
            })
        }
    }

    const getPubs = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'id':id, 'user':user.id})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/findUserCrawlPubs`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setPubs(result)
                    getCrawl()
                },
                (error) => {console.log(error)}
            )
    }

    const getCrawl = () => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'id':id})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/getCrawl`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    setCrawl(result[0])
                },
                (error) => {console.log(error)}
            )
    }

    const pubbed = (value) => {
        if (value == currentPub.pubbed) {
            setOpen(false)
            return
        }

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'id':currentPub.pubbed_id, 'pubbed':value})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/updatePubUser`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    let temp = currentPub
                    temp.pubbed = value
                    setCurrentPub(temp)
                    setOpen(false)
                    if (value) fire()
                },
                (error) => {console.log(error)}
            )
    }

    const updateCrawl = (updatePub) => {
        let temp = crawl
        if (updatePub > 0 && updatePub <= pubs.length) temp.current_pub = updatePub

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authenticationService.currentUserValue.token}`},
            body: JSON.stringify({'crawl':temp})
        };

        fetch(`${process.env.REACT_APP_API_ROUTES}/pub/updateCrawl`, requestOptions)
            .then(handleResponse)
            .then((result) => {
                    console.log(result)
                    getCrawl()
                },
                (error) => {console.log(error)}
            )
    }

    useEffect(() => {
        getPubs()
    }, [])

    useEffect(() => {
        if (!!pubs && !!crawl && pubs.length > 0 && crawl.id > 0) {
            if (Object.keys(currentPub).length === 0) {
                setCurrentPub(pubs.find(x => x.order === crawl.current_pub))
            } else {
                if (currentPub.pubbed) {
                    window.setTimeout(fire, 1000)
                }
                setCurrentPub(pubs.find(x => x.order === crawl.current_pub))
                setLoaded(true)
            }
        }
    }, [currentPub, pubs, crawl])

    let extra = <></>
    if (user.admin) {
        extra = (
            <div className="text-right">
                <Button title={"Next Pub"} onClick={() => updateCrawl(crawl.current_pub+1)} />
                <Button title={"Prev Pub"} onClick={() => updateCrawl(crawl.current_pub-1)} />
            </div>
        )
    }

    if (loaded) {
        return (
            <>
                <Title title={crawl.title} desc={crawl.desc} extra={extra} />

                <div className="self-center max-w-2xl lg:px-4 sm:px-6 sm:py-6 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:border lg:border-gray-200 lg:bg-white rounded-md">
                    {/* Pub */}
                    <div className="lg:max-w-lg">
                        <div className="mt-4">
                            <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{currentPub.name}</h1>
                        </div>

                        <section aria-labelledby="information-heading" className="mt-4">
                            <div className="flex items-center">
                                <p className="text-lg text-gray-900 sm:text-xl">Start Time: {new Date(currentPub.start_time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit'})}</p>
                            </div>

                            <div className="mt-2 space-y-6">
                                <p className="text-lg text-gray-900 sm:text-xl">End Time: {new Date(currentPub.end_time).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit'})}</p>
                            </div>

                            <div className="mt-2 flex items-center">
                                {currentPub.pubbed ? (
                                    <>
                                        <span className="inline-flex flex-shrink-0 items-center rounded-lg bg-green-400/70 px-1.5 py-0.5 text-lg font-medium text-green-950 ring-1 ring-inset ring-green-800/20">
                                            Inebriated
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span className="inline-flex flex-shrink-0 items-center rounded-lg bg-red-400/70 px-1.5 py-0.5 text-lg font-medium text-red-950 ring-1 ring-inset ring-red-800/20">
                                            Sober
                                        </span>
                                    </>
                                )}
                            </div>
                        </section>
                    </div>

                    {/* Map */}
                    <div className="mt-8 lg:col-start-2 lg:row-span-2 lg:mt-0 lg:self-center">
                        <div className="aspect-square w-full rounded-lg object-cover">
                            <APIProvider apiKey={process.env.REACT_APP_GOOGLE} onLoad={() => console.log('Maps API has loaded.')}>
                                <Map
                                    defaultZoom={15}
                                    defaultCenter={{lat: currentPub.lat, lng: currentPub.long}}
                                    mapId={"226fc07b2976381b"}
                                >
                                    <PubRoute pubs={pubs} currentPub={currentPub} showCompletedRoute={true} />

                                    {pubs.map((item) => (
                                        <AdvancedMarker
                                            key={item.id || item.order}
                                            position={{ lat: item.lat, lng: item.long}}
                                        >
                                            {currentPub.order < item.order && (
                                                <Pin
                                                    background={'#0f679d'}
                                                    borderColor={'#00529d'}
                                                    glyphColor={'#6092b5'}
                                                />
                                            )}

                                            {currentPub.order > item.order && (
                                                <Pin
                                                    background={'#0f9d58'}
                                                    borderColor={'#006425'}
                                                    glyphColor={'#60d98f'}
                                                />
                                            )}

                                            {currentPub.order === item.order && (
                                                <img src={currentPub.pubbed ? "https://i.ibb.co/XPfS0SF/image.png" : "https://i.ibb.co/gZMjcVvG/image.png"} width={88} height={88} alt="Current pub" />
                                            )}
                                        </AdvancedMarker>
                                    ))}
                                </Map>
                            </APIProvider>
                        </div>
                    </div>

                    {/* Product form */}
                    <div className="mt-8 lg:col-start-1 lg:row-start-2 lg:max-w-lg lg:self-start">
                        <section aria-labelledby="options-heading">

                            <div className="flex items-center">
                                <p className="text-lg text-gray-900 sm:text-xl">{currentPub.desc}</p>
                            </div>

                            <div className="my-2 lg:col-start-2 lg:row-span-2 lg:mt-0 lg:self-center">
                                <img alt={currentPub.name} src={currentPub.img} className="aspect-square w-full rounded-lg object-cover" />
                            </div>

                        </section>
                    </div>

                    <div className="flex justify-center">
                        <Button buttonSize={4} title={"I Pubbed"} onClick={() => setOpen(true)} />
                    </div>

                    <div className={open ? "absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity z-[101] flex justify-center items-center" : "-z-10 absolute top-0 left-0 w-dvw h-dvh bg-gray-500 bg-opacity-75 transition-opacity flex justify-center items-center opacity-0"}>
                        <div className="bg-white shadow sm:rounded-lg px-4 py-5 sm:p-6 w-full lg:w-96 h-auto mx-4 text-center flex flex-col items-center">
                            <h3 className="text-base font-semibold leading-6 text-gray-900">
                                I promise sir I have pubbed I have
                            </h3>

                            <div className="mt-5 flex justify-center items-center gap-3">
                                <button
                                    type="button"
                                    className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
                                    onClick={() => pubbed(1)}
                                >
                                    Yes I really have
                                </button>
                                <button
                                    type="button"
                                    className="inline-flex items-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-400"
                                    onClick={() => pubbed(0)}
                                >
                                    Sorry I was lying
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <ReactCanvasConfetti
                    onInit={onInit}
                />

            </>
        )
    } else {
        return (<Loading />)
    }
}

const PubRoute = ({ pubs, currentPub, showCompletedRoute = true }) => {
    const map = useMap();
    const routesLibrary = useMapsLibrary("routes");

    useEffect(() => {
        if (!map || !routesLibrary || pubs.length < 2 || !currentPub?.order) return;

        const orderedPubs = [...pubs]
            .map((pub) => ({
                ...pub,
                lat: Number(pub.lat),
                lng: Number(pub.long),
            }))
            .filter((pub) => Number.isFinite(pub.lat) && Number.isFinite(pub.lng))
            .sort((a, b) => a.order - b.order);

        const currentIndex = orderedPubs.findIndex((pub) => pub.order === currentPub.order);

        if (currentIndex === -1) return;

        const directionsService = new routesLibrary.DirectionsService();
        const directionsRenderers = [];
        let cancelled = false;

        const drawRouteSegment = async (fromPub, toPub, color) => {
            const directionsRenderer = new routesLibrary.DirectionsRenderer({
                map,
                suppressMarkers: true,
                preserveViewport: true,
                polylineOptions: {
                    strokeColor: color,
                    strokeOpacity: 0.9,
                    strokeWeight: 5,
                },
            });

            directionsRenderers.push(directionsRenderer);

            try {
                const response = await directionsService.route({
                    origin: {
                        lat: fromPub.lat,
                        lng: fromPub.lng,
                    },
                    destination: {
                        lat: toPub.lat,
                        lng: toPub.lng,
                    },
                    travelMode: window.google.maps.TravelMode.WALKING,
                });

                if (!cancelled) {
                    directionsRenderer.setDirections(response);
                }
            } catch (error) {
                console.error("Could not draw route segment:", error);
            }
        };

        const drawRoutes = async () => {
            if (showCompletedRoute) {
                for (let i = 0; i < currentIndex; i++) {
                    await drawRouteSegment(orderedPubs[i], orderedPubs[i + 1], "#d32f2f");
                }
            }

            if (currentIndex < orderedPubs.length - 1) {
                await drawRouteSegment(
                    orderedPubs[currentIndex],
                    orderedPubs[currentIndex + 1],
                    "#0f9d58"
                );
            }
        };

        drawRoutes();

        return () => {
            cancelled = true;
            directionsRenderers.forEach((renderer) => renderer.setMap(null));
        };
    }, [map, routesLibrary, pubs, currentPub, showCompletedRoute]);

    return null;
};


export default CrawlView;